import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Check, Plus } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const UpsellCard = ({ upsell, isSelected, onToggle, index }) => {
  const { t, language } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className={`group cursor-pointer transition-all duration-300 ${
        isSelected ? 'ring-2 ring-[#D4AF37]' : ''
      }`}
      onClick={onToggle}
      data-testid={`upsell-card-${upsell.id}`}
    >
      <div className="relative overflow-hidden">
        <img
          src={upsell.image}
          alt={upsell.name[language] || upsell.name.en}
          className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-4 right-4">
          <div
            className={`w-8 h-8 flex items-center justify-center transition-all duration-300 ${
              isSelected
                ? 'bg-[#D4AF37] text-white'
                : 'bg-white/90 text-[#0F1F3C]'
            }`}
          >
            {isSelected ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
          </div>
        </div>
        {upsell.duration && (
          <div className="absolute bottom-4 left-4 flex items-center space-x-1 bg-white/90 px-3 py-1">
            <Clock className="w-3 h-3 text-[#D4AF37]" />
            <span className="text-xs font-sans text-[#0F1F3C]">{upsell.duration}</span>
          </div>
        )}
      </div>
      <div className="p-4 bg-white">
        <h4 className="font-serif text-lg text-[#0F1F3C] mb-2">
          {upsell.name[language] || upsell.name.en}
        </h4>
        <p className="text-[#64748B] text-sm font-sans line-clamp-2 mb-4">
          {upsell.description[language] || upsell.description.en}
        </p>
        <div className="flex items-center justify-between">
          <span className="font-serif text-xl text-[#0F1F3C]">€{upsell.price}</span>
          <span
            className={`text-xs uppercase tracking-wider font-sans font-medium ${
              isSelected ? 'text-[#D4AF37]' : 'text-[#64748B]'
            }`}
          >
            {isSelected ? t('booking.selected') : t('experiences.addToStay')}
          </span>
        </div>
      </div>
    </motion.div>
  );
};
